module.exports = __webpack_public_path__ + "static/img/banner-03.db46ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/banner-03.png
// module id = KpkO
// module chunks = 1